import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { style: {"margin-bottom":"10px"} }, [
  /*#__PURE__*/_createVNode("label", {
    class: "ant-form-item-required",
    style: {"margin":"0 0 0 12px"}
  }, "使用权限：")
], -1)
const _hoisted_4 = { class: "down-icon" }
const _hoisted_5 = { class: "sub-menu" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 确定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_radio = _resolveComponent("a-radio")
  const _component_a_radio_group = _resolveComponent("a-radio-group")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_icon = _resolveComponent("icon")
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.store.state.menu.setMenuState,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.store.state.menu.setMenuState = $event)),
    width: "800px",
    title: "设置菜单",
    class: "set-menu-dialog auto-scroll-dialog",
    afterClose: _ctx.afterClose,
    onCancel: _ctx.afterClose,
    maskClosable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.afterClose
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "label-col": { span: 4 },
        "wrapper-col": { span: 16 },
        class: "form-content"
      }, {
        default: _withCtx(() => [
          (_ctx.detail.action === 'add')
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                label: "父菜单"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.detail.name
                        ? _ctx.detail.name + '【' + _ctx.detail.code + '】'
                        : '根节点'), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            label: "菜单名称",
            name: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.form.name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                placeholder: "请输入菜单名称",
                maxlength: 20
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "菜单编号",
            name: "menuCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                disabled: _ctx.detail.action === 'mod',
                value: _ctx.form.menuCode,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.menuCode = $event)),
                placeholder: "请输入菜单编号",
                maxlength: 20
              }, null, 8, ["disabled", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "url",
            name: "menuUrl"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.form.menuUrl,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.menuUrl = $event)),
                placeholder: "请输入菜单跳转url",
                maxlength: 100
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "是否为数据看板",
            name: "isDashboard"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.form.isDashboard,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.isDashboard = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "菜单备注",
            name: "remark"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                value: _ctx.form.remark,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.remark = $event)),
                placeholder: "请输入菜单备注",
                maxlength: 20
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _hoisted_3,
          _createVNode(_component_a_row, {
            gutter: 20,
            class: "module-list"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moduleList, (item, key) => {
                return (_openBlock(), _createBlock(_component_a_col, {
                  span: 12,
                  class: "module",
                  key: key
                }, {
                  default: _withCtx(() => [
                    _createVNode("span", _hoisted_4, [
                      _createVNode(_component_icon, {
                        class: { expanded: item.expand },
                        scale: "0.5",
                        onClick: ($event: any) => (_ctx.expand(item)),
                        name: "drop_Icon"
                      }, null, 8, ["class", "onClick"])
                    ]),
                    _createVNode(_component_a_checkbox, {
                      class: "checkbox",
                      indeterminate: item.isIndeterminate,
                      onChange: ($event: any) => (_ctx.changeModuleSelected(item)),
                      checked: item.checked,
                      title: item.desc
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.moduleName), 1)
                      ]),
                      _: 2
                    }, 1032, ["indeterminate", "onChange", "checked", "title"]),
                    _createVNode(_Transition, { name: "md-fade-bottom" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode("ul", _hoisted_5, [
                          _createVNode("li", null, [
                            _createVNode(_component_a_checkbox_group, {
                              value: item.checkedList,
                              "onUpdate:value": ($event: any) => (item.checkedList = $event),
                              class: "sub-menu-group"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.permissions, (sub) => {
                                  return (_openBlock(), _createBlock("li", {
                                    key: sub.code
                                  }, [
                                    _createVNode(_component_a_checkbox, {
                                      value: sub.code,
                                      title: sub.name,
                                      class: "checkbox",
                                      onChange: ($event: any) => (_ctx.changeSubModule(item, sub))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("【" + _toDisplayString(sub.name) + "】" + _toDisplayString(sub.path), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "title", "onChange"])
                                  ]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value"])
                          ])
                        ], 512), [
                          [_vShow, item.expand]
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "afterClose", "onCancel"]))
}